export const getErrorMessage = (error: unknown): string => {
    if (error instanceof Error && error.message) {
        return error.message;
    }

    if (typeof error === "string" && error.trim()) {
        return error;
    }

    if (error && typeof error === "object") {
        const maybeMessage = (error as { message?: unknown }).message;
        if (typeof maybeMessage === "string" && maybeMessage.trim()) {
            return maybeMessage;
        }

        const maybeError = (error as { error?: unknown }).error;
        if (typeof maybeError === "string" && maybeError.trim()) {
            return maybeError;
        }

        const maybeDescription = (error as { error_description?: unknown }).error_description;
        if (typeof maybeDescription === "string" && maybeDescription.trim()) {
            return maybeDescription;
        }
    }

    return "An unexpected error occurred.";
};

export const logError = (context: string, error: unknown) => {
    console.error(`${context}: ${getErrorMessage(error)}`, error);
};